import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { ICrudGetProps } from '@monorepo/tools/src/lib/interfaces/crud';
import { useLocation } from 'react-router-dom';
import { IAdminxStore } from '../../stores';

export function useCampaignGroupGet(props: ICrudGetProps) {
	const { id, options } = props;
	const { campaignGroupsStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (id) {
			campaignGroupsStore.getCrud().get(id, options);
		}
	}, [location]);

	if (!id) {
		return null;
	}

	return { error: campaignGroupsStore.getCrud().getHttpError(), isLoading: campaignGroupsStore.getCrud().getIsLoading() };
}
